<template>
  <BaseInnerLoading v-if="isLoading" />

  <p v-else-if="isError"> a </p>

  <template v-else-if="paymentRequest">
    <div class="space-y-6">
      <p class="text-center text-3xl text-background-fg/87">
        {{ currentTenant?.name }}
      </p>

      <BaseCard
        class="flex flex-wrap items-center justify-between"
      >
        <div class="flex-1">
          <p class="text-lg font-semibold">
            {{ paymentRequest.customer.name }}
          </p>
          <p
            v-if="paymentRequest.customer.email"
            class="flex items-center text-sm text-background-fg/87"
          >
            <IconHeroiconsEnvelope class="mr-2" />

            {{ paymentRequest.customer.email }}
          </p>
          <p
            v-if="paymentRequest.customer.phone"
            class="flex items-center text-sm text-background-fg/87"
          >
            <IconHeroiconsPhone class="mr-2" />
            {{ paymentRequest.customer.phone }}
          </p>
        </div>
      </BaseCard>

      <div class="text-sm">
        <div
          class="flex flex-wrap justify-between space-x-4"
        >
          <div class="text-background-fg/70"> Status </div>
          <div class="text-right">
            <PaymentStatusChip
              :status="paymentRequest.status"
            />
          </div>
        </div>

        <div
          class="flex flex-wrap justify-between space-x-4"
        >
          <div class="text-background-fg/70"> Date </div>
          <div class="text-right">
            {{ formatToDate(paymentRequest.createdAt) }}
          </div>
        </div>

        <div
          class="flex flex-wrap justify-between space-x-4"
        >
          <div class="text-background-fg/70"> Time </div>
          <div class="text-right">
            {{ formatToTime(paymentRequest.createdAt) }}
          </div>
        </div>

        <div
          class="flex flex-wrap justify-between space-x-4"
        >
          <div class="text-background-fg/70"
            >Description</div
          >
          <div class="text-right">
            {{ paymentRequest.description }}
          </div>
        </div>
      </div>

      <div
        class="text-center text-4xl font-semibold text-primary"
      >
        {{
          formatToCurrencyString(paymentRequest.amountGross)
        }}
      </div>

      <ButtonPrimary
        v-if="paymentRequest.status === 'requested'"
        :is-loading="isPaying"
        class="w-full"
        @click="onPay"
      >
        Pay Now
      </ButtonPrimary>
    </div>
  </template>
</template>

<script setup lang="ts">
const props = defineProps<{
  paymentId: string
}>()
const {
  data: paymentRequest,
  isLoading,
  isError,
} = usePaymentRequest(props.paymentId)

const { currentTenant } = useCurrentTenant()

const isPaying = ref(false)
const onPay = async () => {
  isPaying.value = true
  try {
    await gotoPaymentCheckout(props.paymentId)
  } catch {
    toast.error("Failed to go to checkout")
  } finally {
    isPaying.value = false
  }
}
</script>
